module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-desktop@3x-7ef539126daa87c6dd3c72a83ac5c73d.png";